import { getView, requireAuth } from '@/lib/utils';
import { PageAssetCreate } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/assets/create',
  component: getView('pages/PageAssetEdit'),
  name: 'createNewAsset',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Assets > Create New',
    leftMenu: Left.AssetsList,
    roles: ['operator'],
    information: PageAssetCreate,
    showBottomMenu: true,
  },
};
